export function safeRadarReturnPath(value: unknown): string | null {
  if (typeof value !== "string" || !value.startsWith("/") || value.startsWith("//")) return null;
  try {
    const parsed = new URL(value, "https://bdse.local");
    if (parsed.origin !== "https://bdse.local") return null;
    if (parsed.pathname === "/radar" || parsed.pathname.startsWith("/radar/t/")) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
  } catch {
    return null;
  }
  return null;
}
